import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./Winners.css";

const Winners = () => {
  const location = useLocation();

  return (
    <>
      {location.pathname === "/winners" && (
        <Helmet>
          <title>
            New Vikinglotto Winners – Best Licensed Lottery Success Stories
          </title>
          <meta
            name="description"
            content="Discover the best Vikinglotto winners! Play on our licensed platform for a chance to win big with new, exciting opportunities every draw. Join now and be a winner!"
          />
          <link
            rel="canonical"
            href={`https://lottolegenda.com${location.pathname}`}
          />
        </Helmet>
      )}
      <main className="lottolegenda-main lottolegenda-results-page">
        <section className="lottolegenda-how__body pad pad-top flex">
          <h1>Winners</h1>
          <div className="lottolegenda-winners__grid">
            <div className="lottolegenda-winners__map"></div>
            <div className="lottolegenda-winners__grid-2">
              <div className="lottolegenda-winners__grid-part">
                <p className="col-blue fw-700 t-21">№1521</p>
                <p>
                  Country:{" "}
                  <span className="lottolegenda-result__date">Belgium</span>
                </p>
                <p>
                  Draw Date:{" "}
                  <span className="lottolegenda-result__date">May 7, 2025</span>
                </p>
                <p>
                  Prize:{" "}
                  <span className="lottolegenda-result__date">€10,800,000</span>
                </p>
                <p>
                  Category:{" "}
                  <span className="lottolegenda-result__date">
                    6 Numbers + Viking Number
                  </span>
                </p>
              </div>
              <div className="lottolegenda-winners__grid-part">
                <p className="col-blue fw-700 t-21">№1519</p>
                <p>
                  Country:{" "}
                  <span className="lottolegenda-result__date">Finland</span>
                </p>
                <p>
                  Draw Date:{" "}
                  <span className="lottolegenda-result__date">
                    April 13, 2025
                  </span>
                </p>
                <p>
                  Prize:{" "}
                  <span className="lottolegenda-result__date">€11,500,000</span>
                </p>
                <p>
                  Category:{" "}
                  <span className="lottolegenda-result__date">
                    Jackpot Winner
                  </span>
                </p>
              </div>
              <div className="lottolegenda-winners__grid-part">
                <p className="col-blue fw-700 t-21">№1516</p>
                <p>
                  Country:{" "}
                  <span className="lottolegenda-result__date">Denmark</span>
                </p>
                <p>
                  Draw Date:{" "}
                  <span className="lottolegenda-result__date">
                    March 28, 2025
                  </span>
                </p>
                <p>
                  Prize:{" "}
                  <span className="lottolegenda-result__date">€7,200,000</span>
                </p>
                <p>
                  Category:{" "}
                  <span className="lottolegenda-result__date">
                    Jackpot Winner
                  </span>
                </p>
              </div>
              <div className="lottolegenda-winners__grid-part">
                <p className="col-blue fw-700 t-21">№1511</p>
                <p>
                  Country:{" "}
                  <span className="lottolegenda-result__date">Norway</span>
                </p>
                <p>
                  Draw Date:{" "}
                  <span className="lottolegenda-result__date">May 7, 2025</span>
                </p>
                <p>
                  Prize:{" "}
                  <span className="lottolegenda-result__date">€8,200,000</span>
                </p>
                <p>
                  Category:{" "}
                  <span className="lottolegenda-result__date">
                    6 Numbers + Viking Number
                  </span>
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="lottolegenda-stories pad pad-top flex">
          <h2>Winner Stories & Interviews</h2>
          <div className="lottolegenda-results__container">
            <div className="lottolegenda-stories__part">
              <p className="lottolegenda-stories__header">
                “I kept it secret for a year”
              </p>
              <p className="col-blue t-21 fw-700">€11.5 million</p>
              <p className="lottolegenda-stories__text">
                "I told no one. Not even my family at first. I kept going to
                work for several months while quietly planning my early
                retirement. It was surreal — like living two lives. Now, I
                finally feel free."
              </p>
            </div>
            <div className="lottolegenda-stories__part">
              <p className="lottolegenda-stories__header">
                “The win brought us back together”
              </p>
              <p className="col-blue t-21 fw-700">€7.2 million</p>
              <p className="lottolegenda-stories__text">
                "We had been struggling financially and even emotionally as a
                couple. Winning helped us pay off debt and buy a home. But more
                importantly, it gave us space to reconnect as a family."
              </p>
            </div>
            <div className="lottolegenda-stories__part">
              <p className="lottolegenda-stories__header">
                “We bought a camper and left everything behind”
              </p>
              <p className="col-blue t-21 fw-700">€8.2 million</p>
              <p className="lottolegenda-stories__text">
                "We always dreamed of exploring Europe. So we sold the house,
                bought a campervan, and hit the road. Every sunrise in a new
                country feels like a reminder of how lucky we are."
              </p>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Winners;
